export default __webpack_public_path__ + "static/media/item-5.3ee90202.webp";